/** Collects cleanup callbacks (listeners, subscriptions, textures) and runs them once. */
export class Disposer {
  private fns: (() => void)[] = [];
  private disposed = false;

  add(fn: () => void): void {
    if (this.disposed) {
      fn();
      return;
    }
    this.fns.push(fn);
  }

  listen<K extends keyof HTMLElementEventMap>(
    target: HTMLElement,
    type: K,
    fn: (ev: HTMLElementEventMap[K]) => void,
    opts?: AddEventListenerOptions,
  ): void;
  listen(target: EventTarget, type: string, fn: (ev: Event) => void, opts?: AddEventListenerOptions): void;
  listen(target: EventTarget, type: string, fn: (ev: never) => void, opts?: AddEventListenerOptions): void {
    target.addEventListener(type, fn as EventListener, opts);
    this.add(() => target.removeEventListener(type, fn as EventListener, opts));
  }

  timeout(fn: () => void, ms: number): void {
    const id = window.setTimeout(fn, ms);
    this.add(() => window.clearTimeout(id));
  }

  dispose(): void {
    if (this.disposed) return;
    this.disposed = true;
    for (let i = this.fns.length - 1; i >= 0; i--) {
      try {
        this.fns[i]?.();
      } catch (err) {
        console.error('dispose failed', err);
      }
    }
    this.fns = [];
  }
}
